import { Paginator } from 'primeng/paginator';

/*
 * PrimeNG 12 and earlier always reported at least one page (`Math.ceil(totalRecords / rows) || 1`).
 * PrimeNG 14 returns 0 when there are no records, and Paginator.changePage() silently does nothing
 * unless 0 <= page < pageCount. The app relies on `paginator.changePage(...)` to trigger data loading
 * (search buttons, reloadPage() after delete, lookup modals, ...), so with 0 records - e.g. the first
 * time a lookup modal opens, or after an empty search - no API call was ever made.
 *
 * Restoring the old page count keeps that pattern working everywhere without editing every page.
 */
Paginator.prototype.getPageCount = function (): number {
    return Math.ceil(this.totalRecords / this.rows) || 1;
};
